import { render, staticRenderFns } from "./SendEventModal.vue?vue&type=template&id=6b406c1a&scoped=true"
import script from "./SendEventModal.vue?vue&type=script&lang=js"
export * from "./SendEventModal.vue?vue&type=script&lang=js"
import style0 from "./SendEventModal.vue?vue&type=style&index=0&id=6b406c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b406c1a",
  null
  
)

export default component.exports